import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const FeedTypeList = Loadable(lazy(() => import("./FeedTypeList")));
const FeedTypeForm = Loadable(lazy(() => import("./FeedTypeForm")));

const feedTypeRoutes = [
    {
        path: "/FeedType/FeedTypeList",
        element: <FeedTypeList />,
        permission: PERMISSIONS.FeedTypes.Menu,
    },
    {
        path: "/FeedType/FeedTypeForm",
        element: <FeedTypeForm />,
    },
    {
        path: "/FeedType/FeedTypeForm/:feedTypeId",
        element: <FeedTypeForm />,
    },
];

export default feedTypeRoutes;
